import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Mock } from 'types/global'

export const MocksSectorServiceNow:Mock[] = [ 
    { 
        'url': `/resource/notification/list_all_notifications%7C0,10,1,null,null,null,null,recent,null`, 
        'method': 'GET', 
        'data': {
            "navbar": [
                {
                    "id": 1,
                    "name": "Novas",
                    "unread": "6211",
                    "number": "6403",
                    "total": "0"
                },
                {
                    "id": 2,
                    "name": "Aguardando",
                    "number": "105291",
                    "total": "0"
                },
                {
                    "id": 3,
                    "name": "Em tratamento",
                    "number": "4991",
                    "total": "0"
                },
                {
                    "id": 4,
                    "name": "Pendentes",
                    "number": "228",
                    "total": "0"
                },
                {
                    "id": 5,
                    "name": "Finalizada",
                    "number": "198028",
                    "total": "0"
                },
                {
                    "id": 6,
                    "name": "Arquivada",
                    "number": "20631",
                    "total": "0"
                },
                {
                    "id": 7,
                    "name": "Minhas notificações",
                    "number": "0",
                    "total": "0"
                },
                {
                    "id": 8,
                    "name": "Todas",
                    "number": "335572",
                    "total": "0"
                }
            ],
            "select_location": {
                "enabled": true
            },
            "select_sector": {
                "enabled": true
            },
            "current_tab_selected": 1,
            "list_notifications": [
                {
                    "incident_type": {
                        "display_value": "Alta a Pedido",
                        "value": "alta_a_pedido"
                    },
                    "involves_patient": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": "2 ou mais pacientes",
                        "value": "dois_ou_mais_pacientes"
                    },
                    "incident_description": {
                        "display_value": "JJ-080120250924-NOTMASSA",
                        "value": "JJ-080120250924-NOTMASSA"
                    },
                    "reporter_name": {
                        "display_value": "MASSA SEM DANO",
                        "value": "MASSA SEM DANO"
                    },
                    "sys_updated_on": {
                        "display_value": "08/01/2025 11:38:21",
                        "value": "2025-01-08 14:38:21"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Administração/ Recepção",
                        "value": "2c0c52091b237118bcd687bfe54bcbf2"
                    },
                    "u_attachments_string": {
                        "display_value": "treinamentoTDD.pdf",
                        "value": "treinamentoTDD.pdf"
                    },
                    "number": {
                        "display_value": "HIS0ZGNKQQLI0",
                        "value": "HIS0ZGNKQQLI0"
                    },
                    "incident_title": {
                        "display_value": "JJ-080120250924-NOTMASSA",
                        "value": "JJ-080120250924-NOTMASSA"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "786978",
                        "value": "786978"
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "08/01/2025 09:25:10",
                        "value": "2025-01-08 12:25:10"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "user1.qualidor@rededor.com.br",
                        "value": "user1.qualidor@rededor.com.br"
                    },
                    "u_attachments_url": {
                        "display_value": "https://notifica-attach-hml.s3.us-east-1.amazonaws.com/94b2b133-2ba6-434c-8c70-e434b4668aa4.pdf",
                        "value": "https://notifica-attach-hml.s3.us-east-1.amazonaws.com/94b2b133-2ba6-434c-8c70-e434b4668aa4.pdf"
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "JJ-080120250924-NOTMASSA",
                        "value": "JJ-080120250924-NOTMASSA"
                    },
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "BA - Hospital Aeroporto",
                        "value": "1b61436d1be45d504e95a68fe54bcb55"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "0d208354878396101109ec240cbb35e1",
                        "value": "0d208354878396101109ec240cbb35e1"
                    },
                    "reporter_sector": {
                        "display_value": "Almoxarifado",
                        "value": "8cf0bfd81b81f114d83e0dcbe54bcbd0"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Sem dano",
                        "value": "62270310dbb6a1108394816404961970"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "3",
                        "value": "3"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "21",
                        "value": "21"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "08/01/2025",
                        "value": "2025-01-08"
                    },
                    "u_notification_read": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores de contexto institucional",
                        "value": "fatores_de_contexto_institucional"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Comportamento inadequado",
                        "value": "comportamento_inadequado"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "O Gestor do setor André e a enfermeira Rafafela não estão alinhaados com a falas/orientações e informações dentro do setor,confundindo muitas vezes os funcionarios que se sentem acuados e confusos com as varias informações passadas e não estão batendo. cada enfermeiro da uma orientação diferente do que o André fala e a Rafafela tbm fala outra coisa. isto tem impacto bastante para novos erros do setor. E o proporio gestor vasa informações de funcionarios de dentro do setor para outros do mesmo, falta de etica.",
                        "value": "O Gestor do setor André e a enfermeira Rafafela não estão alinhaados com a falas/orientações e informações dentro do setor,confundindo muitas vezes os funcionarios que se sentem acuados e confusos com as varias informações passadas e não estão batendo. cada enfermeiro da uma orientação diferente do que o André fala e a Rafafela tbm fala outra coisa. isto tem impacto bastante para novos erros do setor. E o proporio gestor vasa informações de funcionarios de dentro do setor para outros do mesmo, falta de etica."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 01:20:53",
                        "value": "2025-01-05 04:20:53"
                    },
                    "u_notification_creation_month": {
                        "display_value": "12",
                        "value": "12"
                    },
                    "incident_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HIS98ABUFUTTK",
                        "value": "HIS98ABUFUTTK"
                    },
                    "incident_title": {
                        "display_value": "comportamento",
                        "value": "comportamento"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 01:20:53",
                        "value": "2025-01-05 04:20:53"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2024",
                        "value": "2024"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "notificação",
                        "value": "notificação"
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital e Maternidade São Luiz São Caetano",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "8e84315b3b3612948f2df647f4e45a01",
                        "value": "8e84315b3b3612948f2df647f4e45a01"
                    },
                    "reporter_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "03/12/2024",
                        "value": "2024-12-03"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": null,
                        "value": ""
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Comportamento inadequado",
                        "value": "comportamento_inadequado"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "A NOVA LIDER DO SETOR, CHAMA ATENÇÃO DO FUNCIONARIO NA FRENTE DE TODO MUNDO. MAND MENSAGEM FORA DO PERIODO DE TRABALHO MUITAS VEZES. NÃO AJUDA O FUNCIONARIO, NAO TEM BOA COMUNICAÇÃO COM O GESTOR DO SETOR ENEM COM OS ENFERMEIROS,POIS CADA UMA TEM UMA INFORMAÇÃO DIFERENTE DO QUE ELA FALA. ",
                        "value": "A NOVA LIDER DO SETOR, CHAMA ATENÇÃO DO FUNCIONARIO NA FRENTE DE TODO MUNDO. MAND MENSAGEM FORA DO PERIODO DE TRABALHO MUITAS VEZES. NÃO AJUDA O FUNCIONARIO, NAO TEM BOA COMUNICAÇÃO COM O GESTOR DO SETOR ENEM COM OS ENFERMEIROS,POIS CADA UMA TEM UMA INFORMAÇÃO DIFERENTE DO QUE ELA FALA. "
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 01:10:46",
                        "value": "2025-01-05 04:10:46"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISEFGEQEEI9D",
                        "value": "HISEFGEQEEI9D"
                    },
                    "incident_title": {
                        "display_value": "MAL COMPORTAMENTO",
                        "value": "MAL COMPORTAMENTO"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 01:10:46",
                        "value": "2025-01-05 04:10:46"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "ABRIR NOTIFICAÇÃO",
                        "value": "ABRIR NOTIFICAÇÃO"
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital e Maternidade São Luiz São Caetano",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "6532b5973b3612948f2df647f4e45a3c",
                        "value": "6532b5973b3612948f2df647f4e45a3c"
                    },
                    "reporter_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "shift_incident": {
                        "display_value": "Não sei informar",
                        "value": "not_known"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores do time (equipes)",
                        "value": "fatores_do_time_equipes"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Comportamento inadequado",
                        "value": "comportamento_inadequado"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "Enfermeira Juliana do PSA ajuda os seus técnicos a realizarem descanso dentro do setor do PSA no BOX 16, contendo varias poltronas e alguns técnicos usam box 13, sendo assim realizando descanso de mais de 2 horas chegando as vezes a 3 por plantão, como o supervisor Rogerio diversas vezes que na rede dor, não existe descanso que temos que dividir nosso horário de janta em 20 minutos para jantar e 40 para \" esticar as pernas\" como diz o Rogerio, ele já advertiu diversas vezes outros setores por causa de minutos de alguns técnicos passaram ou perdeu noção do tempo em descanso e porque o PSA pode descansar no setor e fazer 3 horas, será pela amizade entre Rogerio e Romulo supervisor então um setor tem esse privilegio ?.\nE isso os próprios técnicos dos setores confirmam isso das horas dos descanso, então já que somo proibidos de descansar pelo supervisor Rogerio, essa conduta do pessoal do PSA tem que ser supervisionada também, pois sabemos que em alguns setores os supervisores do dia ficam vasculhando as câmeras de segurança para verificar se os colaboradores estão trabalhando, ou quando tempo estão no banheiro e por que entrou em tal sala e por que ficou tanto tempo nesta sala, então esta havendo camaradagem para alguns e para outros só bronca.\n",
                        "value": "Enfermeira Juliana do PSA ajuda os seus técnicos a realizarem descanso dentro do setor do PSA no BOX 16, contendo varias poltronas e alguns técnicos usam box 13, sendo assim realizando descanso de mais de 2 horas chegando as vezes a 3 por plantão, como o supervisor Rogerio diversas vezes que na rede dor, não existe descanso que temos que dividir nosso horário de janta em 20 minutos para jantar e 40 para \" esticar as pernas\" como diz o Rogerio, ele já advertiu diversas vezes outros setores por causa de minutos de alguns técnicos passaram ou perdeu noção do tempo em descanso e porque o PSA pode descansar no setor e fazer 3 horas, será pela amizade entre Rogerio e Romulo supervisor então um setor tem esse privilegio ?.\nE isso os próprios técnicos dos setores confirmam isso das horas dos descanso, então já que somo proibidos de descansar pelo supervisor Rogerio, essa conduta do pessoal do PSA tem que ser supervisionada também, pois sabemos que em alguns setores os supervisores do dia ficam vasculhando as câmeras de segurança para verificar se os colaboradores estão trabalhando, ou quando tempo estão no banheiro e por que entrou em tal sala e por que ficou tanto tempo nesta sala, então esta havendo camaradagem para alguns e para outros só bronca.\n"
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 01:08:25",
                        "value": "2025-01-05 04:08:25"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Pronto Socorro Adulto",
                        "value": "52907b5c1b817514739e53111b4bcb87"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISQWQ5G4KKOR",
                        "value": "HISQWQ5G4KKOR"
                    },
                    "incident_title": {
                        "display_value": "Enfermeira Juliana do PSA.",
                        "value": "Enfermeira Juliana do PSA."
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 01:08:25",
                        "value": "2025-01-05 04:08:25"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "Infelizmente não há o que ser feito, pois camaradagem fala mais alto.",
                        "value": "Infelizmente não há o que ser feito, pois camaradagem fala mais alto."
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital e Maternidade São Luiz Campinas",
                        "value": "0dc18b6d1be45d504e95a68fe54bcb1a"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "63a1391f3b76965496633447f4e45aa5",
                        "value": "63a1391f3b76965496633447f4e45aa5"
                    },
                    "reporter_sector": {
                        "display_value": "Enfermagem",
                        "value": "5e0c16411bebf914739e53111b4bcbae"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores individuais (pessoas)",
                        "value": "fatores_individuais_pessoas"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Desvio de qualidade de produtos",
                        "value": "desvio_de_qualidade_de_produtos"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "FUI JANTAR E VI O PESSOL RECLAANDO DAS MISTURAS DO DIA WUE FOI FRICASSE DE FRANGO E CARNE AO MOLHO ACHO QUE MADEIRA, ENFIM UMA COLEGA DE TRABALHO PASSOU MAL E VOMITOU MUITO E DEPOIS MAIS EU COMECEI A SENTIR MAL ESTAR, DOR NO ESTOMAGO,AZIA E DIARREIA. NÃO E A PRIMEIRA VEZ QUE PEGAMOS INFECCÃO INTESTINAL COM A COMIDA SERVIDA NO ESTABELECIMENTO.",
                        "value": "FUI JANTAR E VI O PESSOL RECLAANDO DAS MISTURAS DO DIA WUE FOI FRICASSE DE FRANGO E CARNE AO MOLHO ACHO QUE MADEIRA, ENFIM UMA COLEGA DE TRABALHO PASSOU MAL E VOMITOU MUITO E DEPOIS MAIS EU COMECEI A SENTIR MAL ESTAR, DOR NO ESTOMAGO,AZIA E DIARREIA. NÃO E A PRIMEIRA VEZ QUE PEGAMOS INFECCÃO INTESTINAL COM A COMIDA SERVIDA NO ESTABELECIMENTO."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 01:06:20",
                        "value": "2025-01-05 04:06:20"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Nutrição",
                        "value": "c3f0b7501b0df9909cac32681b4bcbdc"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISGIUKD85NL4",
                        "value": "HISGIUKD85NL4"
                    },
                    "incident_title": {
                        "display_value": "REFEIÇÃO CONTAMINADA ?",
                        "value": "REFEIÇÃO CONTAMINADA ?"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 01:06:20",
                        "value": "2025-01-05 04:06:20"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "AVISADO E ENFERMEIRO QUE TAMBÉM FOI TESTEMUNHA QUE ESTAVAMOS PASSANDO MAL E ELE PEDIU PRA NOTIFICAR.",
                        "value": "AVISADO E ENFERMEIRO QUE TAMBÉM FOI TESTEMUNHA QUE ESTAVAMOS PASSANDO MAL E ELE PEDIU PRA NOTIFICAR."
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital e Maternidade São Luiz São Caetano",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "34317d9bfb32da54def2f683aeefdc70",
                        "value": "34317d9bfb32da54def2f683aeefdc70"
                    },
                    "reporter_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Dano moderado",
                        "value": "cbd08798db76a11083948164049619e2"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "03/01/2025",
                        "value": "2025-01-03"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores do time (equipes)",
                        "value": "fatores_do_time_equipes"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Falha na comunicação na realização do transporte",
                        "value": "falha_na_comunicacao_na_realizacao_do_transporte"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "Recebemos uma paciente da maternidade para o centro obstétrico para a realização de uma revisão de canal de parto acompanhada da equipe médica, porém o recém nascido veio no colo da enfermeira. No protocolo fica proibido transitar com RN sem segurança, com o mesmo no colo. O transporte seguro de um RN é na maca com a mãe em seu top. Além do mais que o RN veio sem fralda, sem identificação, somente enrolado no pano. Sendo que foi uma intercorrência durante o trabalho de parto e a paciente teve que descer, mas acabou vindo acompanhante e RN, coisa que não necessitava pois o parto já havia ocorrido.",
                        "value": "Recebemos uma paciente da maternidade para o centro obstétrico para a realização de uma revisão de canal de parto acompanhada da equipe médica, porém o recém nascido veio no colo da enfermeira. No protocolo fica proibido transitar com RN sem segurança, com o mesmo no colo. O transporte seguro de um RN é na maca com a mãe em seu top. Além do mais que o RN veio sem fralda, sem identificação, somente enrolado no pano. Sendo que foi uma intercorrência durante o trabalho de parto e a paciente teve que descer, mas acabou vindo acompanhante e RN, coisa que não necessitava pois o parto já havia ocorrido."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 00:59:41",
                        "value": "2025-01-05 03:59:41"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Maternidade",
                        "value": "fb51739c1b81f1d0bcd687bfe54bcbe4"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISUB4LVYDAXW",
                        "value": "HISUB4LVYDAXW"
                    },
                    "incident_title": {
                        "display_value": "Risco de queda",
                        "value": "Risco de queda"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 00:59:41",
                        "value": "2025-01-05 03:59:41"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "A técnica responsável pelos cuidados do RN pegou o bebê e imediatamente foi colocado em berço aquecido e orientado que essa situação não pode acontecer, pois é risco de queda ou até mesmo rapto de RN, pois nem identificado estava. Foi realizado os cuidados do RN e identificado.",
                        "value": "A técnica responsável pelos cuidados do RN pegou o bebê e imediatamente foi colocado em berço aquecido e orientado que essa situação não pode acontecer, pois é risco de queda ou até mesmo rapto de RN, pois nem identificado estava. Foi realizado os cuidados do RN e identificado."
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "DF - Hospital Santa Helena",
                        "value": "4b5a75fe1bfa7810bcd687bfe54bcbd5"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "abafad97fb32da54def2f683aeefdcfe",
                        "value": "abafad97fb32da54def2f683aeefdcfe"
                    },
                    "reporter_sector": {
                        "display_value": "Centro Obstétrico",
                        "value": "8041fbd81b81f1d0bcd687bfe54bcb16"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Sem dano",
                        "value": "62270310dbb6a1108394816404961970"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores do time (equipes)",
                        "value": "fatores_do_time_equipes"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Falha na integração dos sistemas",
                        "value": "falha_na_integração_dos_sistemas"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "SOU INFORMADA DA AUSÊNCIA DO SISTEMA TASY E, POR CONSEQUÊNCIA, DEVIDO AO GRANDE VOLUME DE PACIENTES NO AGUARDO POR ATENDIMENTO NO PSGO, DA NECESSIDADE DE UTILIZAÇÃO DO SISTEMA DE CONTINGÊNCIA. REALIZO ATENDIMENTOS, SOLICITAÇÃO DE EXAMES E, CONSEQUENTEMENTE, INTERNAÇÃO NAQUELAS COM TAL INDICAÇÃO. APÓS TAIS FEITOS, SOU INFORMADA PELA SUPERVISÃO DE ENFERMAGEM E PELO SETOR DE INTERNAÇÃO QUE É NECESSÁRIO REALIZAR TUDO NOVAMENTE NO SISTEMA TASY. OU SEJA, TODO TRABALHO EFETUADO EM VÃO. ALÉM DO MAIS, A MANUTENÇÃO DO SISTEMA NÃO FORA AVISADO PREVIAMENTE O CORPO CLÍNICO. ISTO É, SEM COMUNICAÇÃO PRÉVIA, SEM ORIENTAÇÃO DO TEMPO PARA CONCLUIR O PROCESSO DE MANUTENÇÃO E COM OS PROFISSIONAIS DESGASTADOS PELO DESCASO. ",
                        "value": "SOU INFORMADA DA AUSÊNCIA DO SISTEMA TASY E, POR CONSEQUÊNCIA, DEVIDO AO GRANDE VOLUME DE PACIENTES NO AGUARDO POR ATENDIMENTO NO PSGO, DA NECESSIDADE DE UTILIZAÇÃO DO SISTEMA DE CONTINGÊNCIA. REALIZO ATENDIMENTOS, SOLICITAÇÃO DE EXAMES E, CONSEQUENTEMENTE, INTERNAÇÃO NAQUELAS COM TAL INDICAÇÃO. APÓS TAIS FEITOS, SOU INFORMADA PELA SUPERVISÃO DE ENFERMAGEM E PELO SETOR DE INTERNAÇÃO QUE É NECESSÁRIO REALIZAR TUDO NOVAMENTE NO SISTEMA TASY. OU SEJA, TODO TRABALHO EFETUADO EM VÃO. ALÉM DO MAIS, A MANUTENÇÃO DO SISTEMA NÃO FORA AVISADO PREVIAMENTE O CORPO CLÍNICO. ISTO É, SEM COMUNICAÇÃO PRÉVIA, SEM ORIENTAÇÃO DO TEMPO PARA CONCLUIR O PROCESSO DE MANUTENÇÃO E COM OS PROFISSIONAIS DESGASTADOS PELO DESCASO. "
                    },
                    "reporter_name": {
                        "display_value": "DAMARIS DE FREITAS BATISTA ",
                        "value": "DAMARIS DE FREITAS BATISTA "
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 00:51:58",
                        "value": "2025-01-05 03:51:58"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "PSGO - Pronto Socorro de Ginecologia e Obstetrícia",
                        "value": "242484ce87f40218f230a6c30cbb3503"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISBM0VM02R4U",
                        "value": "HISBM0VM02R4U"
                    },
                    "incident_title": {
                        "display_value": "QUEDA DE SISTEMA TASY / CONTINGÊNCIA ",
                        "value": "QUEDA DE SISTEMA TASY / CONTINGÊNCIA "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 00:51:58",
                        "value": "2025-01-05 03:51:58"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "SOU INFORMADA DA AUSÊNCIA DO SISTEMA TASY E, POR CONSEQUÊNCIA, DEVIDO AO GRANDE VOLUME DE PACIENTES NO AGUARDO POR ATENDIMENTO NO PSGO, DA NECESSIDADE DE UTILIZAÇÃO DO SISTEMA DE CONTINGÊNCIA. REALIZO ATENDIMENTOS, SOLICITAÇÃO DE EXAMES E, CONSEQUENTEMENTE, INTERNAÇÃO NAQUELAS COM TAL INDICAÇÃO. APÓS TAIS FEITOS, SOU INFORMADA PELA EQUIPE DE INTERNAÇÃO QUE É NECESSÁRIO REALIZAR TUDO NOVAMENTE NO SISTEMA TASY. OU SEJA, TODO TRABALHO EFETUADO EM VÃO. ALÉM DO MAIS, A MANUTENÇÃO DO SISTEMA NÃO FORA AVISADO PREVIAMENTE O CORPO CLÍNICO. ISTO É, SEM COMUNICAÇÃO PRÉVIA, SEM ORIENTAÇÃO DO TEMPO PARA CONCLUIR O PROCESSO DE MANUTENÇÃO E COM OS PROFISSIONAIS DESGASTADOS PELO DESCASO. ",
                        "value": "SOU INFORMADA DA AUSÊNCIA DO SISTEMA TASY E, POR CONSEQUÊNCIA, DEVIDO AO GRANDE VOLUME DE PACIENTES NO AGUARDO POR ATENDIMENTO NO PSGO, DA NECESSIDADE DE UTILIZAÇÃO DO SISTEMA DE CONTINGÊNCIA. REALIZO ATENDIMENTOS, SOLICITAÇÃO DE EXAMES E, CONSEQUENTEMENTE, INTERNAÇÃO NAQUELAS COM TAL INDICAÇÃO. APÓS TAIS FEITOS, SOU INFORMADA PELA EQUIPE DE INTERNAÇÃO QUE É NECESSÁRIO REALIZAR TUDO NOVAMENTE NO SISTEMA TASY. OU SEJA, TODO TRABALHO EFETUADO EM VÃO. ALÉM DO MAIS, A MANUTENÇÃO DO SISTEMA NÃO FORA AVISADO PREVIAMENTE O CORPO CLÍNICO. ISTO É, SEM COMUNICAÇÃO PRÉVIA, SEM ORIENTAÇÃO DO TEMPO PARA CONCLUIR O PROCESSO DE MANUTENÇÃO E COM OS PROFISSIONAIS DESGASTADOS PELO DESCASO. "
                    },
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital e Maternidade São Luiz Osasco",
                        "value": "275af5fe1bfa7810bcd687bfe54bcb08"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "d2edad1f3bfe965494dd6137f4e45a7a",
                        "value": "d2edad1f3bfe965494dd6137f4e45a7a"
                    },
                    "reporter_sector": {
                        "display_value": "PSGO - Pronto Socorro de Ginecologia e Obstetrícia",
                        "value": "242484ce87f40218f230a6c30cbb3503"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Tecnologia e sistemas eletrônicos de informação",
                        "value": "fatores_da_tarefa_e_da_tecnologia"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Lesão de Pele",
                        "value": "skin_injury"
                    },
                    "involves_patient": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": "1 paciente",
                        "value": "um_paciente"
                    },
                    "incident_description": {
                        "display_value": "paciente admitida apresentando lesão auto infligida involuntária em região da falange distal, da mão Direita, devido quadro clinico, Alzheimer avançado e por muitas veze força ficar e permanece/manter punho cerrado, acompanhante rela já ter tido outras lesões na palma da mão.",
                        "value": "paciente admitida apresentando lesão auto infligida involuntária em região da falange distal, da mão Direita, devido quadro clinico, Alzheimer avançado e por muitas veze força ficar e permanece/manter punho cerrado, acompanhante rela já ter tido outras lesões na palma da mão."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 00:47:21",
                        "value": "2025-01-05 03:47:21"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Emergência Adulto",
                        "value": "5e0c9ac11b2f31949cac32681b4bcbcb"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISY7HNAUB6UW",
                        "value": "HISY7HNAUB6UW"
                    },
                    "incident_title": {
                        "display_value": "Admissão com lesão auto infligida involuntária",
                        "value": "Admissão com lesão auto infligida involuntária"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 00:47:21",
                        "value": "2025-01-05 03:47:21"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "7688402",
                        "value": "7688402"
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "Realizo curativo compressivo e oclusivo com cobertura primaria adaptic e ocluído com aze e transpore para melhor fixação não região ",
                        "value": "Realizo curativo compressivo e oclusivo com cobertura primaria adaptic e ocluído com aze e transpore para melhor fixação não região "
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "DF - Hospital Santa Luzia",
                        "value": "cb5a75fe1bfa7810bcd687bfe54bcbd6"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "2adca55b3bfe965494dd6137f4e45a18",
                        "value": "2adca55b3bfe965494dd6137f4e45a18"
                    },
                    "reporter_sector": {
                        "display_value": "UTI Ad - Térreo",
                        "value": "5f0c00511b6146dc4e95a68fe54bcb9d"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "damage_level": {
                        "display_value": "Dano leve",
                        "value": "6e37039cdb76a110839481640496191f"
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "M.S.F",
                        "value": "M.S.F"
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": null,
                        "value": ""
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Atraso na reposição de material ou medicamento",
                        "value": "atraso_na_reposicao_de_material_ou_medicamento"
                    },
                    "involves_patient": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": null,
                        "value": ""
                    },
                    "incident_description": {
                        "display_value": "VENHO POR MEIO DESTE DEIXAR NOTIFICADO EVENTO QUE COM RELATIVA FREQUENCIA VEM OCORRENDO NOS PLANTÕES COM O ENFERMEIRO LUAN.\n\nHOJE EM MEIO A UM PLANTÃO EXTREMAMENTE CONTURBADO TIVEMOS ATENDEMOS AO PACIENTE SERGIO DE SOUZA EVANGELISTA QUE DEU ENTRADA NESTE PS COM QUADRO DE CONVULSÃO REENTRANTE, QUE EVOLUI COM PERDA DA PROTEÇÃO DA VIA AÉREA SENDO NECESSÁRIO INTUBAÇÃO. APÓS TAL PROCEDIMENTO O PACIENTE FOI ESTABILIZADO E LEVADO A UTI ONDE FOI DADO SEGUIMENTO AO SEU ATENDIMENTO. NA OCASIÃO FORAM PRESCRITAS TODAS AS MEDICAÇÕES CONTROLADAS USADAS POR VOLTA DAS 17:58H CONFORME SOLICITADO PELA EQUIPE DE ENFERMAGEM. PORÉM, SOMENTE POR VOLTA DAS 00:10H O ENFERMEIRO LUAN VEIO ATÉ MIM SOLICITAR QUE AS MEDICAÇOES UTILIZADAS NA OCASIÃO FOSSEM NOVAMENTE PRESCRITAS, POIS JÁ HAVIA PASSADO MAIS DO QUE UMA HORA E QUE NÃO TERIA MAIS COMO PEGAR AS MEDICAÇÕES PARA FAZER A DEVIDA REPOSIÇÃO. EU O QUESTIONEI A CERCA DO MOTIVO PELO QUAL A MEDICAÇÃO NÃO FOI REPOSTA NA OCASIÃO EM QUE HAVIA SIDO PRESCRITA O MESMO FOI EXTREMAMENTE DESAGRADÁVEL INSULTANDO-ME DIZENDO QUE CASO EU NÃO PRESCREVESSE O MESMO IRIA DEIXAR FORMALIZADO O FATO. POIS BEM, VENHO TAMBÉM FAZER A MINHA PARTE DA FORMALIZAÇÃO DO OCORRIDO UMA VEZ QUE HOUVE ERRO POR PARTE DA ENFERMAGEM, QUE SÓ VEIO PREOCUPAR-SE EM REPOR AS MEDICAÇÕES UTILIZADAS POR VOLTA DAS 17:30H ÀS 00:10H, OU SEJA, 07H DEPOIS. AGORA IMAGINA SE CHEGA UM NOVO PACIENTE DÁ ENTRADA NO PS COM NECESSIDADE DE USO DAS MESMAS MEDICAÇÕES E ESTAS NÃO ESTÃO DISPONIVEIS PARA USO PORQUE ALGUÉM NÃO REALIZOU A TAREFA QUE LHE CABIA NO DEVIDO HORÁRIO. UM MAL MAIOR PODERIA INCORRER AO PACIENTE.\n\nALÉM DISSO, BEM MAIS CEDO, ESTAVA EU REALIZANDO A SUTURA DE UM PACIENTE (OU SEJA, ESTAVA PARAMENTADO) COM ESPECTRO ALTISTA, POUCO COLABORATIVO, PRECISANDO DE FAMILIARES E TÉCNICO PARA AJUDAR A CONTER O PACIENTE, VEIO O MESMO ENFERMEIRO ME PERGUNTAR SE EU PODERIA SUBIR COM ELE UM PACIENTE DE UTI QUE ESTAVA COM LEITO LIBERADO PARA SUBIR. MAIS UMA VEZ O COLEGA ENFERMEIRO AGIU (ASSIM COMO EM MUITA",
                        "value": "VENHO POR MEIO DESTE DEIXAR NOTIFICADO EVENTO QUE COM RELATIVA FREQUENCIA VEM OCORRENDO NOS PLANTÕES COM O ENFERMEIRO LUAN.\n\nHOJE EM MEIO A UM PLANTÃO EXTREMAMENTE CONTURBADO TIVEMOS ATENDEMOS AO PACIENTE SERGIO DE SOUZA EVANGELISTA QUE DEU ENTRADA NESTE PS COM QUADRO DE CONVULSÃO REENTRANTE, QUE EVOLUI COM PERDA DA PROTEÇÃO DA VIA AÉREA SENDO NECESSÁRIO INTUBAÇÃO. APÓS TAL PROCEDIMENTO O PACIENTE FOI ESTABILIZADO E LEVADO A UTI ONDE FOI DADO SEGUIMENTO AO SEU ATENDIMENTO. NA OCASIÃO FORAM PRESCRITAS TODAS AS MEDICAÇÕES CONTROLADAS USADAS POR VOLTA DAS 17:58H CONFORME SOLICITADO PELA EQUIPE DE ENFERMAGEM. PORÉM, SOMENTE POR VOLTA DAS 00:10H O ENFERMEIRO LUAN VEIO ATÉ MIM SOLICITAR QUE AS MEDICAÇOES UTILIZADAS NA OCASIÃO FOSSEM NOVAMENTE PRESCRITAS, POIS JÁ HAVIA PASSADO MAIS DO QUE UMA HORA E QUE NÃO TERIA MAIS COMO PEGAR AS MEDICAÇÕES PARA FAZER A DEVIDA REPOSIÇÃO. EU O QUESTIONEI A CERCA DO MOTIVO PELO QUAL A MEDICAÇÃO NÃO FOI REPOSTA NA OCASIÃO EM QUE HAVIA SIDO PRESCRITA O MESMO FOI EXTREMAMENTE DESAGRADÁVEL INSULTANDO-ME DIZENDO QUE CASO EU NÃO PRESCREVESSE O MESMO IRIA DEIXAR FORMALIZADO O FATO. POIS BEM, VENHO TAMBÉM FAZER A MINHA PARTE DA FORMALIZAÇÃO DO OCORRIDO UMA VEZ QUE HOUVE ERRO POR PARTE DA ENFERMAGEM, QUE SÓ VEIO PREOCUPAR-SE EM REPOR AS MEDICAÇÕES UTILIZADAS POR VOLTA DAS 17:30H ÀS 00:10H, OU SEJA, 07H DEPOIS. AGORA IMAGINA SE CHEGA UM NOVO PACIENTE DÁ ENTRADA NO PS COM NECESSIDADE DE USO DAS MESMAS MEDICAÇÕES E ESTAS NÃO ESTÃO DISPONIVEIS PARA USO PORQUE ALGUÉM NÃO REALIZOU A TAREFA QUE LHE CABIA NO DEVIDO HORÁRIO. UM MAL MAIOR PODERIA INCORRER AO PACIENTE.\n\nALÉM DISSO, BEM MAIS CEDO, ESTAVA EU REALIZANDO A SUTURA DE UM PACIENTE (OU SEJA, ESTAVA PARAMENTADO) COM ESPECTRO ALTISTA, POUCO COLABORATIVO, PRECISANDO DE FAMILIARES E TÉCNICO PARA AJUDAR A CONTER O PACIENTE, VEIO O MESMO ENFERMEIRO ME PERGUNTAR SE EU PODERIA SUBIR COM ELE UM PACIENTE DE UTI QUE ESTAVA COM LEITO LIBERADO PARA SUBIR. MAIS UMA VEZ O COLEGA ENFERMEIRO AGIU (ASSIM COMO EM MUITA"
                    },
                    "reporter_name": {
                        "display_value": "CLEISON BRITO",
                        "value": "CLEISON BRITO"
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 00:45:31",
                        "value": "2025-01-05 03:45:31"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "Pronto Socorro Adulto",
                        "value": "52907b5c1b817514739e53111b4bcb87"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISEJKGOPC2QR",
                        "value": "HISEJKGOPC2QR"
                    },
                    "incident_title": {
                        "display_value": "ATRASO EM REPOSIÇÃO DE MEDICAÇÃO USADA POR PACIENTE ",
                        "value": "ATRASO EM REPOSIÇÃO DE MEDICAÇÃO USADA POR PACIENTE "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 00:45:31",
                        "value": "2025-01-05 03:45:31"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "SOLICITO QUE SEJA CONVERSADO COM O REFERIDO ENFERMEIRO PRIMEIRAMENTE SOBRE A QUESTÃO DA MEDICAÇÃO QUE NÃO FOI REPOSTA A TEMPO BEM COMO DOS RISCOS QUE TAL ATITUDE PODERIA INCORRER CASO TAIS MEDICAÇÕES PRECISASSEM SER UTILIZADAS UMA VEZ QUE NÃO FORAM REPOSTAS A TEMPO.\n\nSEGUNDO, QUE SEJA CONVERSADO COM O MESMO SOBRE A IMPORTÂNCIA DE APRENDER A ESPERAR QUE O MÉDICO TERMINE ATIVIDADE EM CURSO E NÃO LARGAR TUDO DESESPERADAMENTE OU MANDAR QUE OUTROS COLEGAS DEIXEM A PORTA (MUITAS VEZES COM MUITOS PACIENTES AGUARDANDO UM PRIMEIRO ATENDIMENTO E JÁ COM TEMPO DE ESPERA MAIOR QUE 20MIN, PELA DEMANDA NAQUELE HORÁRIO) SOMENTE PORQUE NAQUELE EXATO MOMENTO, TAL COMO FOI DEIXADO NÍTIDO A ENTENDER, QUE A NECESSIDADE DE LEVAR O PACIENTE A UTI POR PARTE DA ENFERMAGEM FOSSE MAIS IMPORTANTE ATÉ MESMO DO QUE UM ATENDIMENTO EM CURSO.",
                        "value": "SOLICITO QUE SEJA CONVERSADO COM O REFERIDO ENFERMEIRO PRIMEIRAMENTE SOBRE A QUESTÃO DA MEDICAÇÃO QUE NÃO FOI REPOSTA A TEMPO BEM COMO DOS RISCOS QUE TAL ATITUDE PODERIA INCORRER CASO TAIS MEDICAÇÕES PRECISASSEM SER UTILIZADAS UMA VEZ QUE NÃO FORAM REPOSTAS A TEMPO.\n\nSEGUNDO, QUE SEJA CONVERSADO COM O MESMO SOBRE A IMPORTÂNCIA DE APRENDER A ESPERAR QUE O MÉDICO TERMINE ATIVIDADE EM CURSO E NÃO LARGAR TUDO DESESPERADAMENTE OU MANDAR QUE OUTROS COLEGAS DEIXEM A PORTA (MUITAS VEZES COM MUITOS PACIENTES AGUARDANDO UM PRIMEIRO ATENDIMENTO E JÁ COM TEMPO DE ESPERA MAIOR QUE 20MIN, PELA DEMANDA NAQUELE HORÁRIO) SOMENTE PORQUE NAQUELE EXATO MOMENTO, TAL COMO FOI DEIXADO NÍTIDO A ENTENDER, QUE A NECESSIDADE DE LEVAR O PACIENTE A UTI POR PARTE DA ENFERMAGEM FOSSE MAIS IMPORTANTE ATÉ MESMO DO QUE UM ATENDIMENTO EM CURSO."
                    },
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hospital Brasil Mauá",
                        "value": "6b5ab5fe1bfa7810bcd687bfe54bcbfa"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "847c291b3bb2da5440b46747f4e45a12",
                        "value": "847c291b3bb2da5440b46747f4e45a12"
                    },
                    "reporter_sector": {
                        "display_value": "Pronto Socorro Adulto",
                        "value": "52907b5c1b817514739e53111b4bcb87"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "05/01/2025",
                        "value": "2025-01-05"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores individuais (pessoas)",
                        "value": "fatores_individuais_pessoas"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "incident_type": {
                        "display_value": "Falha na identificação do paciente",
                        "value": "falha_na_identificacao_do_paciente"
                    },
                    "involves_patient": {
                        "display_value": "verdadeiro",
                        "value": "true"
                    },
                    "u_attachments_presigned_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_number_patients_involved": {
                        "display_value": "1 paciente",
                        "value": "um_paciente"
                    },
                    "incident_description": {
                        "display_value": "Paciente recebeu dieta errada",
                        "value": "Paciente recebeu dieta errada"
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "05/01/2025 00:34:03",
                        "value": "2025-01-05 03:34:03"
                    },
                    "u_notification_creation_month": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "incident_sector": {
                        "display_value": "UTI NEO - Unidade de Terapia Intensiva / Neonatal",
                        "value": "ea523fd81bc17514739e53111b4bcb1a"
                    },
                    "u_attachments_string": {
                        "display_value": "",
                        "value": ""
                    },
                    "number": {
                        "display_value": "HISZBTQQP0DOO",
                        "value": "HISZBTQQP0DOO"
                    },
                    "incident_title": {
                        "display_value": "Erro na identificação do paciente",
                        "value": "Erro na identificação do paciente"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_attachments_size": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_disclosure_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_never_events": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_on": {
                        "display_value": "05/01/2025 00:34:03",
                        "value": "2025-01-05 03:34:03"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_observation_incident_classification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_certifier_accreditor_protocol": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "u_notifica_user": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_attachments_url": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_notification_creation_year": {
                        "display_value": "2025",
                        "value": "2025"
                    },
                    "u_probability_occurence": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "7657926",
                        "value": "7657926"
                    },
                    "u_attachments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_image_risk": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_note_external_notification": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_managers_review": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "work_notes": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "dieta em bomba de infusão, parado dieta assim que o erro foi percebido e descartado dieta. ",
                        "value": "dieta em bomba de infusão, parado dieta assim que o erro foi percebido e descartado dieta. "
                    },
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reason_for_archiving": {
                        "display_value": null,
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "DF - Hospital Santa Helena",
                        "value": "4b5a75fe1bfa7810bcd687bfe54bcbd5"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "18/12/2024",
                        "value": "2024-12-18"
                    },
                    "u_attachments_html": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "u_archiving_observations": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_incident_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "sys_id": {
                        "display_value": "ffc9211ffbfe9a54def2f683aeefdc7b",
                        "value": "ffc9211ffbfe9a54def2f683aeefdc7b"
                    },
                    "reporter_sector": {
                        "display_value": "UTI NEO - Unidade de Terapia Intensiva / Neonatal",
                        "value": "ea523fd81bc17514739e53111b4bcb1a"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "damage_level": {
                        "display_value": "Sem dano",
                        "value": "62270310dbb6a1108394816404961970"
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "u_disclosure": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_initials": {
                        "display_value": "R.N.A.P.S.C",
                        "value": "R.N.A.P.S.C"
                    },
                    "u_notification_multiplier": {
                        "display_value": "1",
                        "value": "1"
                    },
                    "sys_tags": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "04/01/2025",
                        "value": "2025-01-04"
                    },
                    "u_notification_read": {
                        "display_value": "falso",
                        "value": "false"
                    },
                    "u_notification_comments": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_categorized_contributing_factor": {
                        "display_value": "Fatores individuais (pessoas)",
                        "value": "fatores_individuais_pessoas"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_reviewed_by": {
                        "display_value": "",
                        "value": ""
                    }
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.sector.get.byid('00222d8adb25611083948164049619f6'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'u_name': 'Programação Avançada',
                    'u_count_inactive': '100',
                    'sys_id': '00222d8adb25611083948164049619f6',
                    'u_active': 'true',
                    'u_count_active': '8'
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.sector.post.create, 
        'method': 'POST', 
        'data': {
            'result': {
                'u_name': 'Produção',
                'u_count_inactive': '108',
                'u_active': 'true',
                'u_count_active': '0'
            }
        }
    },
    { 
        'url': ROUTES_NAMES.sector.get.all_paginate('0', '10'), 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'u_name': 'Programação Avançada',
                    'u_count_inactive': '100',
                    'sys_id': '00222d8adb25611083948164049619f6',
                    'u_active': 'true',
                    'u_count_active': '8'
                },
                {
                    'u_name': 'Tecnologia da Informação (TI)',
                    'u_count_inactive': '104',
                    'sys_id': '054333e9dba12110839481640496192a',
                    'u_active': 'true',
                    'u_count_active': '4'
                },
                {
                    'u_name': 'Produção',
                    'u_count_inactive': '108',
                    'sys_id': '28c3828cdbfde5108394816404961906',
                    'u_active': 'true',
                    'u_count_active': '0'
                },
                {
                    'u_name': 'Enfermaria',
                    'u_count_inactive': '108',
                    'sys_id': '2ef780621b65e11060d9426fe54bcbee',
                    'u_active': 'true',
                    'u_count_active': '0'
                },
                {
                    'u_name': 'Telefonia 123',
                    'u_count_inactive': '107',
                    'sys_id': '4475e36edbe5e11083948164049619f2',
                    'u_active': 'true',
                    'u_count_active': '1'
                },
                {
                    'u_name': 'Recepção',
                    'u_count_inactive': '104',
                    'sys_id': '75637fa9dba12110839481640496191c',
                    'u_active': 'true',
                    'u_count_active': '4'
                },
                {
                    'u_name': 'Ambulatório',
                    'u_count_inactive': '51',
                    'sys_id': 'bb53bfa9dba1211083948164049619a1',
                    'u_active': 'true',
                    'u_count_active': '57'
                },
                {
                    'u_name': 'Gerência',
                    'u_count_inactive': '107',
                    'sys_id': 'd72d983d1b65211060d9426fe54bcbff',
                    'u_active': 'true',
                    'u_count_active': '1'
                }
            ]
        }
    },
    
    { 
        'url': ROUTES_NAMES.sector.get.all, 
        'method': 'GET', 
        'data': {
            'result': [
                {
                    'u_name': 'Programação Avançada',
                    'u_count_inactive': '108',
                    'sys_id': '00222d8adb25611083948164049619f6',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '0'
                },
                {
                    'u_name': 'Tecnologia da Informação (TI)',
                    'u_count_inactive': '104',
                    'sys_id': '054333e9dba12110839481640496192a',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '4'
                },
                {
                    'u_name': 'Enfermaria',
                    'u_count_inactive': '108',
                    'sys_id': '2ef780621b65e11060d9426fe54bcbee',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '0'
                },
                {
                    'u_name': 'Telefonia 123',
                    'u_count_inactive': '108',
                    'sys_id': '4475e36edbe5e11083948164049619f2',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '0'
                },
                {
                    'u_name': 'Recepção',
                    'u_count_inactive': '104',
                    'sys_id': '75637fa9dba12110839481640496191c',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '4'
                },
                {
                    'u_name': 'Ambulatório',
                    'u_count_inactive': '51',
                    'sys_id': 'bb53bfa9dba1211083948164049619a1',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '57'
                },
                {
                    'u_name': 'Gerência',
                    'u_count_inactive': '108',
                    'sys_id': 'd72d983d1b65211060d9426fe54bcbff',
                    'u_active': 'Verdadeiro',
                    'u_count_active': '0'
                }
            ]
        }
    },
    { 
        'url': ROUTES_NAMES.sector.put.update('00222d8adb25611083948164049619f6'), 
        'method': 'PUT', 
        'data': {
            'result': {
                'u_name': {
                    'display_value': 'Programação Avançada - Editado',
                    'value': 'Programação Avançada'
                },
                'u_count_inactive': {
                    'display_value': '108',
                    'value': '108'
                },
                'sys_id': {
                    'display_value': '00222d8adb25611083948164049619f6',
                    'value': '00222d8adb25611083948164049619f6'
                },
                'u_active': {
                    'display_value': 'Verdadeiro',
                    'value': 'true'
                },
                'u_count_active': {
                    'display_value': '0',
                    'value': '0'
                }
            }
        }
    },
    { 
        'url': ROUTES_NAMES.sector.get.all_paginate('0', '10', {field: 'u_name', order: 'ORDERBY'}), 
        'method': 'GET', 
        'data': {
            "result": [
              {
                "u_name": "Acolhimento Cirúrgico",
                "u_count_inactive": "130",
                "sys_id": "09a57dd11b51fd509cac32681b4bcb1d",
                "u_active": "Verdadeiro",
                "u_count_active": "1"
              },
              {
                "u_name": "Agendamento Cirúrgico",
                "u_count_inactive": "130",
                "sys_id": "e7ee4e111b9575d0739e53111b4bcbcc",
                "u_active": "Verdadeiro",
                "u_count_active": "1"
              },
              {
                "u_name": "Almoxarifado",
                "u_count_inactive": "129",
                "sys_id": "8cf0bfd81b81f114d83e0dcbe54bcbd0",
                "u_active": "Verdadeiro",
                "u_count_active": "3"
              },
              {
                "u_name": "Almoxarifado - CD Santa Maria",
                "u_count_inactive": "131",
                "sys_id": "afd5bdd11bd97550d83e0dcbe54bcbaf",
                "u_active": "Verdadeiro",
                "u_count_active": "0"
              },
              {
                "u_name": "Almoxarifado - SIA",
                "u_count_inactive": "130",
                "sys_id": "d35639191bd97550d83e0dcbe54bcb89",
                "u_active": "Verdadeiro",
                "u_count_active": "1"
              },
              {
                "u_name": "Ambulatório",
                "u_count_inactive": "130",
                "sys_id": "06864af31bb871909cac32681b4bcbeb",
                "u_active": "Verdadeiro",
                "u_count_active": "2"
              },
              {
                "u_name": "Ambulatório - Cemed",
                "u_count_inactive": "131",
                "sys_id": "e378bd151b91fd509cac32681b4bcbaa",
                "u_active": "Verdadeiro",
                "u_count_active": "0"
              },
              {
                "u_name": "Anestesiologia",
                "u_count_inactive": "130",
                "sys_id": "b9a8f9551b91fd509cac32681b4bcba1",
                "u_active": "Verdadeiro",
                "u_count_active": "1"
              },
              {
                "u_name": "Atendimento",
                "u_count_inactive": "130",
                "sys_id": "fbd83dd51b91fd509cac32681b4bcb17",
                "u_active": "Verdadeiro",
                "u_count_active": "1"
              },
              {
                "u_name": "Auditoria de contas",
                "u_count_inactive": "130",
                "sys_id": "4d01f35c1b81f114d83e0dcbe54bcb05",
                "u_active": "Verdadeiro",
                "u_count_active": "2"
              }
            ],
            "stats": {
              "count": "82"
            }
          }
    }
]